// extracted by mini-css-extract-plugin
export default {"wrapper":"ShowCalculation_wrapper__XOvTJ"};